<script>
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import RbxDatePicker from '../../../shared/reybex/RbxDatePicker';
import fieldVisibilityMixin from '../../../mixins/fieldVisibility';

export default {
  name: 'AvContractExamForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxDatePicker,
  },
  mixins: [fieldVisibilityMixin],
  props: {
    avContract: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hiddenFieldsDomain: 'avContract',
    };
  },
  methods: {
    onDateInput(newDate) {
      this.avContract.examDate = newDate;
    },
  },
};
</script>

<template>
  <div class="avContract-detail-tab main-tab">
    <v-layout row wrap>
      <!-- Basic information left column -->
      <v-flex md12 xs12>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.legalExam')" xs12 md6 py-0>
            <v-radio-group v-model="avContract.legalExam" column label="Rechtliche Prüfung">
              <v-radio label="nicht geprüft" value="0"/>
              <v-radio label="geprüft" value="1"/>
              <v-radio label="k.A." value="2" />
            </v-radio-group>
          </v-flex>

          <v-flex v-if="isFieldVisible('avContract.toExam')" xs12 md6 py-0>
            <v-radio-group
              v-model="avContract.toExam"
              column
              label="Technische / organisatorische Prüfung"
            >
              <v-radio label="nicht geprüft" value="0"/>
              <v-radio label="geprüft" value="1"/>
              <v-radio label="k.A." value="2" />
            </v-radio-group>
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.legelExamNotes')" xs12 md6 py-0>
            <v-textarea
              v-model="avContract.legelExamNotes"
              label="Notiz"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('avContract.toExamNotes')" xs12 md6 py-0>
            <v-textarea
              v-model="avContract.toExamNotes"
              label="Notiz"
              class="caption"
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.commentOnTheExam')" xs12 md6 py-0>
            <v-textarea
              v-model="avContract.commentOnTheExam"
              label="Anmerkungen zur Prüfung"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('avContract.examDate')" xs12 md6 py-0>
            <rbx-date-picker
              label="Datum der Prüfung"
              :value="avContract.examDate"
              @input="onDateInput"
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.examState')" xs12 md6 py-0>
            <rbx-remote-combobox
              v-model="avContract.examState"
              label="Status"
              :selected="avContract.examState"
              domain="examState"
            />
          </v-flex>

        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
